// Based on TiMessengerTestTreiber.yaml 2.0.0
/**
 * Client authorization mode
 */
export type AuthorizationMode = 'AllowAll' | 'BlockAll';

export const AuthorizationMode = {
  AllowAll: 'AllowAll' as AuthorizationMode,

  BlockAll: 'BlockAll' as AuthorizationMode
};
